import { PropTypes } from '@amzn/stencil-react-desc';
export var describedPersonalDetails = {
  businessTitle: PropTypes.string.description('Business title of the displayed employee.'),
  businessTitleHiddenText: PropTypes.string.description('Hidden label for the business title.'),
  level: PropTypes.number.description('Job level of the displayed employee.'),
  departmentName: PropTypes.string.description('Department name where the displayed employee works in.'),
  departmentId: PropTypes.string.description('Department id where the displayed employee works in.'),
  departmentHiddenText: PropTypes.string.description('Hidden label for the department.'),
  city: PropTypes.string.description('City where the displayed employee works.'),
  country: PropTypes.string.description('Country where the displayed employee works.'),
  locationHiddenText: PropTypes.string.description('Hidden label for the location.')
};